import { render, staticRenderFns } from "./paper_detail_list.vue?vue&type=template&id=74fe2d50&scoped=true"
import script from "./paper_detail_list.vue?vue&type=script&lang=js"
export * from "./paper_detail_list.vue?vue&type=script&lang=js"
import style0 from "./paper_detail_list.vue?vue&type=style&index=0&id=74fe2d50&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74fe2d50",
  null
  
)

export default component.exports